/* eslint-disable */ 
var searchID = document.getElementById('gsearch');

if ( searchID != null ) {

var buttons = document.getElementById('showHideBtn');
let searchInput = document.getElementById('generalsearch');
let keywordInput = document.getElementById('search_scope_content');
let hideSearchinput = document.getElementById('hideGeneralsearch');

function replaceSymbols(text) {
    // The list of symbols and words
    const symbols = ["AND", "OR", "NOT", "\\(", "\\)", "“", "”", "\\+", "\\-", "\\|"];
    
    // Join the symbols into a regex pattern
    const pattern = symbols.join('|');
    
    // The regex to match symbols/words at the beginning, end, or elsewhere in the string
    const regex = new RegExp(`^(${pattern})|(${pattern})$|(${pattern})`, 'g');
    
    // Function to perform the replacement
    return text.replace(regex, (match, p1, p2, p3) => {
        if (p1) {
            // If the match is at the start of the string, replace with a blank space
            return ' ';
        } else if (p2) {
            // If the match is at the end of the string, replace with a blank space
            return ' ';
        } else if (p3) {
            // If the match is elsewhere, replace with a comma
            return ',';
        }
        return match;
    }).replace(/\s+/g, ' ').trim(); // Ensure any multiple spaces are replaced by a single space and trim any leading/trailing spaces
}


buttons.addEventListener('click', function handleClick() {
            const initialText = 'Multi-Field Search';
            if (
                this.firstElementChild.textContent.toLowerCase() === initialText.toLowerCase()
            ) {
                hideSearchinput.setAttribute('value', searchInput.value);
                keywordInput.setAttribute('value',replaceSymbols(searchInput.value));
                searchInput.value = '';
                $('html, body').animate({
                        scrollTop: $('div.search-radio').offset().top
                }, 1000); // The duration of the animation in milliseconds
                this.firstElementChild.textContent = 'Close Multi-Field Search';
            } else {
                keywordInput.setAttribute('value','');
                searchInput.value = hideSearchinput.value;
                this.firstElementChild.textContent = initialText;
            }
    });

}

/* eslint-enable */ 